// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeliveryReport-module__container___V076d {
    position: relative;
    flex-direction: column;
    display: flex;
    flex-grow: 1;
    overflow: hidden;
}

.DeliveryReport-module__contentWrapper___x2Cqm {
    padding-top: 0;
    z-index: 1;
    display: flex;
    flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/DeliveryReport/DeliveryReport.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,aAAa;IACb,YAAY;AAChB","sourcesContent":[".container {\n    position: relative;\n    flex-direction: column;\n    display: flex;\n    flex-grow: 1;\n    overflow: hidden;\n}\n\n.contentWrapper {\n    padding-top: 0;\n    z-index: 1;\n    display: flex;\n    flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DeliveryReport-module__container___V076d`,
	"contentWrapper": `DeliveryReport-module__contentWrapper___x2Cqm`
};
export default ___CSS_LOADER_EXPORT___;
